import React from 'react';
import ServiceDetailPage from './Common/ServiceDetailPage';

const ServiceCrossPlatformAppDevelopment = () => {
  return (
    <ServiceDetailPage
      title="Cross Platform App Development"
      heading="One product experience across multiple platforms"
      intro="App Core Innovation helps businesses reach users quickly with cross-platform mobile apps that work smoothly on both iOS and Android. This approach reduces development effort while keeping the experience polished and consistent."
      imageSrc="/assets/images/banner/web-designer-programmer-working-desktop-computer-cartoon-woman-coding-different-programming-languages_102902-7000.avif"
      imageAlt="Cross platform app development illustration"
      features={[
        'Shared codebase for faster delivery across platforms',
        'React Native and Flutter-based development options',
        'Consistent UI and reusable business logic',
        'Flexible deployment for startups and growing brands'
      ]}
      deliverables={[
        'Shared architecture and product screens',
        'Platform-ready implementation and testing',
        'App store support and release readiness',
        'Future feature roadmap planning'
      ]}
      outcomes={[
        'Faster launch without giving up quality',
        'Greater reach for users across devices',
        'Lower overall development overhead for early-stage products'
      ]}
      stats={[
        { label: 'Delivery speed', value: 'Fast' },
        { label: 'Best fit', value: 'Startups' },
        { label: 'Approach', value: 'Shared codebase' }
      ]}
      sideTitle="Why this service matters"
      sideText="Cross-platform development is often the smartest path when a business wants to reach users quickly without starting from two separate codebases."
    />
  );
};

export default ServiceCrossPlatformAppDevelopment;
